import { render, staticRenderFns } from "./AssociatedCasesRenderer.vue?vue&type=template&id=7caad592&"
import script from "./AssociatedCasesRenderer.vue?vue&type=script&lang=js&"
export * from "./AssociatedCasesRenderer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports